/*
 * AssignmentListItem Messages
 *
 * This contains all the text for the AssignmentListItem component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  scopeOfAssignment: {
    id: 'graphql.AssignmentListItem.scopeOfAssignment',
    defaultMessage: 'Scope of assignment:',
  },
  startAssignment: {
    id: 'graphql.AssignmentListItem.startAssignment',
    defaultMessage: 'Start assignment',
  },
  pendingValidation: {
    id: 'graphql.AssignmentListItem.pendingValidations',
    defaultMessage: 'Pending validation',
  },
  indorsed: {
    id: 'graphql.AssignmentListItem.indorsed',
    defaultMessage: 'Recommended',
  },
  flagged: {
    id: 'graphql.AssignmentListItem.flagged',
    defaultMessage: 'Not Recommended',
  },
  retake: {
    id: 'graphql.AssignmentListItem.retake',
    defaultMessage: 'Re-take this validation',
  },
  viewFeedback: {
    id: 'graphql.AssignmentListItem.viewFeedback',
    defaultMessage: 'View validators feedback',
  },
  votingExpiry: {
    id: 'graphql.AssignmentListItem.votingExpiry',
    defaultMessage: 'Voting Expiry:',
  },
  durationEstimate: {
    id: 'graphql.AssignmentListItem.estimatedDuration',
    defaultMessage: 'Estimated Duration',
  },
});
